import React, { useState } from "react"
import styled from "styled-components"
import useDimensions from "react-use-dimensions"
import { Icon } from "./tableFeatures"
import Pricing from "./priceComponent"
import { PricingHeader, PricingPrice, YekanParagraph, H6 } from "../typography"
import { ReactComponent as Dropdown } from "../../images/dropdown.svg"
import { setColor } from "../../utils/styleFunctions"
import { colors } from "../../utils/styleVariables"
import { PlanButton } from "./styled"

const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  border-left: 1px solid #dfe5eb;
  width: 80%;
  margin: 0 auto;
`

const Col = styled.div`
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex: 1 0 ${props => props.width};
  width: ${props => props.width};
  border-bottom: 1px solid #dfe5eb;
  border-right: 1px solid #dfe5eb;
`

const HeaderCol = styled(Col)`
  height: auto;
  padding: 20px 0;
  flex-direction: column;
  transition: all 0.42s cubic-bezier(0.19, 1, 0.22, 1) 0s;

  &.fixed {
    ${PricingHeader} {
      transition: all 0.42s cubic-bezier(0.19, 1, 0.22, 1) 0s;
      font-size: 2.2rem;
    }
    ${PricingPrice} {
      transition: all 0.42s cubic-bezier(0.19, 1, 0.22, 1) 0s;
      font-size: 1.8rem;
    }
  }
`

const HeaderContainer = styled.div`
  padding-top: 30px;
  margin-top: 0;
  transition: all 0.42s cubic-bezier(0.19, 1, 0.22, 1) 0s;
  &.fixed {
    position: fixed;
    top: 60px;
    right: 0;
    left: 0;
    background: white;
    z-index: 1000;
    box-shadow: inset 0 -1px 0 0 #dfe5eb, 0 20px 15px -21px rgba(0, 0, 0, 0.15);
  }
  &.hidden {
    margin-top: -1000px;
    transition: all 0.42s cubic-bezier(0.19, 1, 0.22, 1) 0s;
  }
`

const MoreContainer = styled.div`
  visibility: hidden;
  height: 0;

  &.opened {
    visibility: visible;
    height: auto;
  }
`

const DropdownButton = styled.span`
  svg {
    transform: ${props => (props.opened ? "rotate(180deg)" : "none")};
  }
`

const DropdownContainer = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 2rem auto;
  align-items: center;
  ${H6} {
    color: white;
    margin-left: 4px;
  }
  & .button {
    cursor: pointer;
    display: flex;
    align-items: center;
    background-color: ${setColor(colors.lightBlue)};
    padding: 10px 14px;
    border-radius: 20px;
  }
`

const Table = ({ features, services }) => (
  <>
    {Object.entries(features).map(([k, v], i) => (
      <RowContainer key={`${k}${i}`}>
        <Col width="40%">
          <YekanParagraph as="span">{v}</YekanParagraph>
        </Col>
        {services.map((s, j) => (
          <Col width="20%" key={`${k}${s[k]}${j}`}>
            <Icon data={s[k]} />
          </Col>
        ))}
      </RowContainer>
    ))}
  </>
)

export const DesktopTable = ({
  plans,
  features,
  price,
  periods,
  moreCopy,
  link,
  periodParams,
}) => {
  const services = plans.map(a => a.services)
  const [ref, dimension] = useDimensions()
  const { y, bottom } = dimension
  const [opened, setOpened] = useState(false)

  return (
    <div ref={ref} className="desktop-table">
      <HeaderContainer
        className={`${y < 65 && "fixed"} ${bottom < 105 && "hidden"}`}
      >
        <RowContainer style={{ borderTop: "1px solid #dfe5eb" }}>
          <HeaderCol width="40%" />
          {plans.map((p, i) => (
            <HeaderCol
              width="20%"
              className={y < 65 && "fixed"}
              key={`${p.title}${i}`}
            >
              <PricingHeader>{p.title}</PricingHeader>
              <Pricing price={p.price[price]} discount={p.discount} />
              {periods[price]}
            </HeaderCol>
          ))}
        </RowContainer>
      </HeaderContainer>
      <Table services={services} features={features[0]} />
      <RowContainer>
        <Col width="40%" style={{ height: "80px" }} />
        {plans.map((p, j) => (
          <Col style={{ height: "80px" }} width="20%" key={`${p.title}${j}`}>
            <PlanButton
              text={p.button.text}
              name={p.button.text}
              maxWidth="100px"
              slug={p.slug}
              icon="basket"
              to={
                p.button.to &&
                `${link}?plan=${p.button.to}&period=${periodParams[price]}`
              }
            />
          </Col>
        ))}
      </RowContainer>

      <DropdownContainer onClick={() => setOpened(prev => !prev)}>
        <div className="button">
          <H6 as="span">{opened ? moreCopy[1] : moreCopy[0]}</H6>
          <DropdownButton opened={opened}>
            <Dropdown />
          </DropdownButton>
        </div>
      </DropdownContainer>
      <MoreContainer className={opened && "opened"}>
        <Table services={services} features={features[1]} />
      </MoreContainer>
    </div>
  )
}
